export interface IOverviewFilters {
  familia: string[];
  departamento?: string;
  grupo?: string;
  subgrupo?: string;
}

export type UpdateOverviewFilterPayload = {
  [K in keyof IOverviewFilters]-?: { key: K; value: IOverviewFilters[K] };
}[keyof IOverviewFilters];

export interface FilterStateOverview {
  filters: IOverviewFilters;
}

export const DEFAULT_OVERVIEW_FILTERS: IOverviewFilters = {
  familia: [],
};
